import { Modal } from '@trackman/web-shared-components';
import React from 'react';
import { Id, Info, Label, LabelWrapper, ModalContent, Name, PlayerWrapper } from './StrikeZoneMissingStyles';
import { IPlayer } from 'interfaces/team/IPlayer';
import { observer } from 'mobx-react-lite';

interface IProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  players: IPlayer[];
}

const StrikeZoneMissingModal: React.FC<IProps> = observer((props) => {
  const { visible, setVisible, players } = props;

  return (
    <Modal
      open={visible}
      onClose={() => setVisible(false)}
      title='Missing strike zone dimensions'
      confirmBtn={{ onClick: () => setVisible(false), label: 'Understood' }}
      maxWidth={'xs'}
    >
      <ModalContent>
        <div>
          <div>The following player(s) does not have custom strike zone dimensions:</div>
          <LabelWrapper>
            <Label>Name:</Label>
            <Label>ID:</Label>
          </LabelWrapper>

          {players.map((player) => {
            return (
              <PlayerWrapper>
                <Name>
                  {player.firstName} {player.lastName}
                </Name>
                <Id>{player.id}</Id>
              </PlayerWrapper>
            );
          })}
        </div>
        <Info>These players will be using the league’s static strike zone for this game.</Info>
      </ModalContent>
    </Modal>
  );
});

export default StrikeZoneMissingModal;
